module.exports = "<!-- <button (click)=\"customEvent()\"> custom event</button> -->\r\n<router-outlet></router-outlet>"